<template>
    <ClassroomLayout>
        <div class="classroom-device">
            <h3>Sorry. Your web browser is preventing the classroom from loading.</h3>
            <p>
                This usually happens when a web browser is out of date or a privacy setting is blocking the video system.
            </p>

            <div class="instructions">
                <p><strong>How to get connected:</strong></p>
                <ol>
                    <li>
                        <strong>Switch Browsers:</strong> Try opening this page using <strong>Google Chrome</strong>, <strong>Safari</strong>, or <strong>Mozilla Firefox</strong>. 
                        <em>(If you opened this from an email or messaging app, copy the link below and paste it into one of these browsers).</em>
                    </li>
                    <li>
                        <strong>Turn off Ad/Privacy Blockers:</strong> If you use an ad blocker, VPN, or strict privacy extension, try turning it off for this website and refresh the page.
                    </li>
                    <li>
                        <strong>Update Your Browser:</strong> Make sure your web browser is updated to its latest version.
                    </li>
                </ol>
            </div>
        </div>
    </ClassroomLayout>
</template>

<script setup>
import ClassroomLayout from "@/components/classroom/ClassroomLayout.vue";
</script>

<style lang="scss" scoped>
.classroom-device {
    text-align: center;
    max-width: 600px;
    padding: 0 20px;
    margin: 0 auto;

    h3 {
        margin-bottom: 24px;
    }

    p {
        line-height: 1.6;
    }

    .instructions {
        text-align: left;
        padding: 20px 24px;
        margin: 24px 0;

        p {
            margin-top: 0;
        }

        ol {
            margin: 0;
            padding-left: 20px;

            li {
                margin-bottom: 12px;
                line-height: 1.5;

                &:last-child {
                    margin-bottom: 0;
                }

                em {
                    display: block;
                    margin-top: 4px;
                    font-size: 0.9em;
                }
            }
        }
    }
}
</style>